import React, { ReactNode, useEffect, useState } from 'react';
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { TProjetoHistorico } from 'src/components/projetos/types';
import theme from 'src/theme/light';
import { ChangeState } from 'src/components/projetos/historico/Historico';
import { useObservable } from 'src/framework/store/storeUtil';
import { categorias_componentes$, cidades$, componentes$, estruturaDistribuicao$ } from 'src/store/global.store';
import { STATUS_PROJETO_PAGAMENTO, TIPO_FATURAMENTO } from 'src/components/projetos/constants';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import { PermissionUtil } from 'src/framework/commons/PermissionUtil';
import moment from 'moment';
import { ID_INVERSOR, ID_MICROINVERSOR } from 'src/components/componentes/types';
import { ORIGEM_HISTORICO_V1 } from '../../HistoricoMigrado';
import { arraySort, formatData } from '../utils/actions';
import { STATUS_PROJETO } from '../utils/constants';
import { Alert } from '@mui/material';
import { green, orange, red } from '@mui/material/colors';
import { CategoriasComponentesHistorico, DEFAULT_CATEGORIAS_COMPONENTES } from '../../Historico/constants';
import { Formater, TypeRecords } from 'src/framework/commons/Formater';

interface ComparisonTableProps {
  dados: TProjetoHistorico[];
  changeState: ChangeState;
}

const styles = makeStyles({
  titulo: {
      fontWeight: "bold",
      border: '1px solid grey'
  },
  alterado: {
      backgroundColor: "#BBE6C9",
      border: '1px solid grey'
  },
  removido: {
      backgroundColor: theme.palette.error.light,
  },
  adicionado: {
      backgroundColor: theme.palette.primary.light,
  },
  header: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      fontWeight: "bold",
  },
  historico_selecionado: {
      backgroundColor: theme.palette.grey[200],
      border: '1px solid grey'
  },
  icon_alterou : {
      color: theme.palette.warning.main,
      fontSize: "14px"
  },
});

const TabelaComparacaoProjetos: React.FC<ComparisonTableProps> = (props) => {
  const classes = styles();
  const componentes = useObservable(componentes$);
  const categoriasComponentes = useObservable(categorias_componentes$);
  const estruturas = useObservable(estruturaDistribuicao$);
  const cidades = useObservable(cidades$);
  const permissoes = PermissionUtil.getPermissions();
  const [categoriaComponentesState, setCategoriaComponentesState] = useState<CategoriasComponentesHistorico[]>(DEFAULT_CATEGORIAS_COMPONENTES);

  function comparaCategoria(a: any, b: any): number {
    const ordemCategorias = ['modulos', 'inversores', 'itens_estrutura', 'acessorios'];
    const idxA = ordemCategorias.indexOf(a.grupo);
    const idxB = ordemCategorias.indexOf(b.grupo);
    if (idxA !== -1 && idxB !== -1) {
      return idxA - idxB;
    }
    else if (idxA !== -1) {
      return -1;
    } else if (idxB !== -1) {
      return 1;
    }
    return 0;
  }
  const maskDate = (date: string | Date, datetime: boolean)=>{
    if (date) {
        const data = new Date(date);

        if (datetime) {
            const formattedData = data.toLocaleString('pt-BR', {
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
            });
            return formattedData;
        } else{
            const formattedData = data.toLocaleString('pt-BR', {
                day: 'numeric',
                month: 'numeric',
                year: 'numeric',
            });
            return formattedData;
        }    
    } else return "-";
}
  const compareRow = ((campo: string, projetos: any, changed: boolean): ReactNode =>{
    switch(campo) {
      case "solucao_sugerida":
        return(<>
          {projetos.map((_historico: any)=>{
            let bodySolucao: ReactNode | null = null;
            let tableSolucao: ReactNode | null = null;
            const { projeto } = _historico;
            if (projeto?.solucao_sugerida && projeto?.tipo === "dimensionado") {
              const _solucao = projeto?.solucao_sugerida?.componentes?.filter((i:any) =>i.quantidade > 0);
              const componentList = _solucao?.map((comp:any) => {
                const _componente = componentes?.data?.find((c: any) => c?.id === comp?.id);
                return {
                  ...comp,
                  _componente,
                  grupo: categoriaComponentesState?.find((cat:CategoriasComponentesHistorico)=>cat.id ===_componente?.categoria_componentes_id)?.grupo
                }
              })?.sort((a: any, b: any)=> comparaCategoria(a, b));
              bodySolucao = componentList?.map((comp: any)=>{
                const _componente = comp?._componente;
                return(<TableRow key={comp?.id}>
                  {PermissionUtil.can(PermissionUtil.PERMISSION_PROJETO_DETALHE_VISUALIZAR_CODIGO_COMPONENTE,permissoes)&&(<TableCell>{comp?.id}</TableCell>)}
                  <TableCell width="auto">{comp?.quantidade}</TableCell>
                  <TableCell width="auto">{_componente?.nome || _componente?.modelo}</TableCell>
                </TableRow>)
              })
            }
            if (bodySolucao) {
              tableSolucao = 
              <TableContainer>
                  <Table size="small">
                      <TableHead>
                          <TableRow>
                              {PermissionUtil.can(PermissionUtil.PERMISSION_PROJETO_DETALHE_VISUALIZAR_CODIGO_COMPONENTE,permissoes)&&(<TableCell style={{fontWeight: 'bold'}} align="left">Código</TableCell>)}
                              <TableCell style={{fontWeight: 'bold'}} width="auto">Qtde.</TableCell>
                              <TableCell style={{fontWeight: 'bold'}} width="auto">Descrição</TableCell>
                          </TableRow>
                      </TableHead>
                      <TableBody>
                          {bodySolucao}
                      </TableBody>
                  </Table>
              </TableContainer>
            }
            return(<TableCell className={changed ? classes.alterado : classes.historico_selecionado}>{tableSolucao || "-"}</TableCell>)
          })}
        </>)
      case "componentes":
        return(<>
          {projetos.map((_historico: any)=>{
            let bodyComponentes: ReactNode | null = null;
            let tableComponentes: ReactNode | null = null;
            const { projeto } = _historico;
            if (projeto?.componentes/* && projeto?.tipo === "dimensionado"*/){
              const _componentes = projeto?.componentes?.filter((i:any) =>i.quantidade > 0/* && i.deleted_at === null*/);
              const componentList = _componentes?.map((comp:any) => {
                const _componente = componentes?.data?.find((c: any) => c?.id === comp?.componente_id);
                return {
                  ...comp,
                  _componente,
                  grupo: categoriaComponentesState?.find((cat:CategoriasComponentesHistorico)=>cat.id ===_componente?.categoria_componentes_id)?.grupo
                }
              })?.sort((a: any, b: any)=> comparaCategoria(a, b));
              
              bodyComponentes = componentList?.map((comp: any)=>{
                let removed: any[] = [];
                let added: any[] = [];
                let edited: any[] = [];
                let color = '';

                const _componente = comp?._componente;
                const firstProject = projetos[0]?.projeto;
                const findFirst = firstProject?.componentes?.filter((i:any) =>i.quantidade > 0)?.find((i:any) => i?.componente_id === _componente?.id);
                
                if (projetos?.length > 1) {
                  if (!findFirst) { 
                    color = green[200];
                    added.push(_componente?.id);
                  }else if (findFirst?.quantidade !== comp?.quantidade) {
                    color = orange[200];
                    edited.push(_componente?.id);
                  }
                  
                  const filter = projetos?.filter((i:any) => Number(i?.id) !== Number(_historico?.id));
                  filter?.forEach((i:any) => {
                    const found = i?.projeto?.componentes?.find((ii:any) => ii?.componente_id === comp?.componente_id);
                    if (!found && !added?.includes(comp?.componente_id) && !edited?.includes(comp?.componente_id)) {
                      removed.push(comp?.componente_id);
                      return;
                    }
                  })

                  if (removed?.includes(comp?.componente_id)) color = red[200];
                }
                
                return(<TableRow key={comp?.componente_id} style={{ backgroundColor: color }}>
                  {PermissionUtil.can(PermissionUtil.PERMISSION_PROJETO_DETALHE_VISUALIZAR_CODIGO_COMPONENTE,permissoes)&&(<TableCell>{comp?.componente_id}</TableCell>)}
                  <TableCell align="left">{comp?.quantidade}</TableCell>
                  <TableCell align="left">{_componente?.nome || _componente?.modelo}</TableCell>
                  {(PermissionUtil.can(PermissionUtil.PERMISSION_PROJETO_DETALHE_VISUALIZAR_VALORES,permissoes)) 
                      &&                             
                      (<TableCell align="left">{Formater.toString(Number(comp?.valor_unitario_original || 0), TypeRecords.CURRENCY) || "-"}</TableCell>)}
                  {(PermissionUtil.can(PermissionUtil.PERMISSION_PROJETO_DETALHE_VISUALIZAR_VALORES,permissoes)) 
                      &&                             
                      (<TableCell align="left">{Formater.toString(Number(comp?.valor_unitario || 0), TypeRecords.CURRENCY) || "-"}</TableCell>)}
                  {(PermissionUtil.can(PermissionUtil.PERMISSION_PROJETO_DETALHE_VISUALIZAR_VALORES,permissoes)) 
                      &&                             
                      (<TableCell align="left">{Formater.toString(Number((comp?.valor_unitario * comp?.quantidade) || 0), TypeRecords.CURRENCY) || "-"}</TableCell>)}
                </TableRow>)
              })
            }
            if (bodyComponentes) {
              tableComponentes = 
              <TableContainer>
                  <Table size="small">
                      <TableHead>
                          <TableRow>
                              {PermissionUtil.can(PermissionUtil.PERMISSION_PROJETO_DETALHE_VISUALIZAR_CODIGO_COMPONENTE,permissoes)&&(<TableCell style={{fontWeight: 'bold'}} align="left">Código</TableCell>)}
                              <TableCell style={{fontWeight: 'bold'}} align="left">Qtde.</TableCell>
                              <TableCell style={{fontWeight: 'bold'}} align="left">Descrição</TableCell>
                              {(PermissionUtil.can(PermissionUtil.PERMISSION_PROJETO_DETALHE_VISUALIZAR_VALORES,permissoes)) 
                                  &&
                                  (<TableCell style={{fontWeight: 'bold'}} align="left">Valor Original</TableCell>)}
                              {(PermissionUtil.can(PermissionUtil.PERMISSION_PROJETO_DETALHE_VISUALIZAR_VALORES,permissoes)) 
                                  &&
                                  (<TableCell style={{fontWeight: 'bold'}} align="left">Valor Final</TableCell>)}
                              {(PermissionUtil.can(PermissionUtil.PERMISSION_PROJETO_DETALHE_VISUALIZAR_VALORES,permissoes)) 
                                  &&
                                  (<TableCell style={{fontWeight: 'bold'}} align="left">Total Final</TableCell> )}
                          </TableRow>
                      </TableHead>
                      <TableBody>
                          {bodyComponentes}
                      </TableBody>
                  </Table>
              </TableContainer>
            }
            return(<TableCell className={classes.historico_selecionado}>{tableComponentes || "-"}</TableCell>)
          })}
        </>)
      case "tipo_faturamento":
        return(<>
          {projetos.map((_historico: any)=>{
            const { projeto } = _historico;
            const _tipoFaturamento = TIPO_FATURAMENTO.find((tipo: any) => tipo.value === projeto?.tipo_faturamento);
            return(<TableCell className={changed ? classes.alterado : classes.historico_selecionado}>
              {_tipoFaturamento?.text || "-"}              
            </TableCell>)
          })}
        </>)
      case "tipo":
        return(<>
          {projetos.map((_historico: any)=>{
            const { projeto } = _historico;
            const _tipoProjeto = projeto?.tipo === 'personalizado' ? 'Projeto Personalizado' : 'Projeto Dimensionado';
              return(<TableCell className={changed ? classes.alterado : classes.historico_selecionado}>
                {_tipoProjeto || "-"}
              </TableCell>)
          })}
        </>)
      case "status_projeto":
        return(<>
          {projetos.map((_historico: any)=>{
            const { projeto } = _historico;
            const status_projeto = STATUS_PROJETO.find((status: any)=>status.value === projeto?.status_projeto);
            return(<TableCell className={changed ? classes.alterado : changed ? classes.alterado : classes.historico_selecionado}>
              {status_projeto?.text || "-"}             
            </TableCell>)
          })}
        </>)      
      case "status_projeto_pagamento":
        return(<>
          {projetos.map((_historico: any)=>{
            const { projeto } = _historico;
            const status_projeto_pagamento = STATUS_PROJETO_PAGAMENTO.find((status: any)=>status.value === projeto?.status_projeto_pagamento);
            return(<TableCell className={changed ? classes.alterado : classes.historico_selecionado}>
              {status_projeto_pagamento?.text || "-"}             
            </TableCell>)
          })}
        </>)
      case "expirado":
        return(<>
          {projetos.map((_historico: any)=>{
            const { projeto } = _historico;
            return(<TableCell className={changed ? classes.alterado : classes.historico_selecionado}>
              {projeto?.expirado ? "Sim" : "Não"}            
            </TableCell>)
          })}
        </>)
      case "termos_projeto":
        return(<>
          {projetos.map((_historico: any)=>{
            const { projeto } = _historico;
            const termos = projeto?.dados_termo;

            return(
            <TableCell className={changed ? classes.alterado : classes.historico_selecionado}>
              <Box style={{display: "flex", alignItems: "center"}}>
                <Box style={{display: "flex"}}>
                    <>{!!termos ? <CheckBoxIcon style={{ color: theme.palette.secondary.main}}/> : <CheckBoxOutlineBlankIcon />}</>
                </Box>
                <Box style={{marginLeft: "10px"}}>
                    {/* <div dangerouslySetInnerHTML={{__html: termos?.texto || ""}}/> */}
                    <strong><p>Termo aceito em: {formatData(termos?.aceito_em) || ""} por: {termos?.usuario || ""}</p></strong>
                </Box>
              </Box>
            </TableCell>)
          })}
        </>)
      case "previsao_faturamento":
        return(<>
          {projetos.map((_historico: any)=>{
            const { projeto } = _historico;
            return(<TableCell className={changed ? classes.alterado : classes.historico_selecionado}>
              {(projeto?.previsao_faturamento && (
                <blockquote style={{borderRadius: '10px', margin: '24px 0', padding: '4px 24px', borderLeft: '5px solid rgb(0, 175, 57)', backgroundColor: 'rgb(226 226 226)'}}>
                  <div dangerouslySetInnerHTML={{__html: projeto?.previsao_faturamento || ""}}/>
                </blockquote>
              )) || "-"}           
            </TableCell>)
          })}
        </>)
      case "aceitou_termos":
        return(<>
          {projetos.map((_historico: any)=>{
            const { projeto } = _historico;
            const projetoAceito = projeto?.origem === ORIGEM_HISTORICO_V1 ? projeto?.dados_migracao?.projetoV1?.AceitouOsTermos : projeto?.dados_termo?.aceito_em;
            return (<TableCell className={changed ? classes.alterado : classes.historico_selecionado}>
              {projetoAceito ? "Sim" : "Não"}
            </TableCell>)
          })}
        </>)
      case "tensao":
        return(<>
          {projetos.map((_historico: any)=>{
            const { projeto } = _historico;
            const tensao = projeto?.solucao_sugerida?.inversor_tensao === 1 ? "127/220" : projeto?.solucao_sugerida?.inversor_tensao === 2 ? "220/380": null;
            return(<TableCell className={changed ? classes.alterado : classes.historico_selecionado}>{tensao || "-"}</TableCell>)
          })}
        </>)
      case "inversor_tipo_conexao":
        return(<>
          {projetos.map((_historico: any)=>{
            const { projeto } = _historico;
            const fase = projeto?.solucao_sugerida?.inversor_tipo_conexao === 1 ? "Monofásico" : (projeto?.solucao_sugerida?.inversor_tipo_conexao === 2 ? "Bifásico" : projeto?.solucao_sugerida?.inversor_tipo_conexao === 3 ? "Trifásico": null);
            return(<TableCell className={changed ? classes.alterado : classes.historico_selecionado}>{fase || "-"}</TableCell>)
          })}
        </>)
      case "tipo_inversor":
        return(<>
          {projetos.map((_historico: any)=>{
            const { projeto } = _historico;
            let tipo = null;

            const tipo_inversor = projeto?.tipo_inversor || projeto?.solucao_sugerida?.tipo_inversor
            if (tipo_inversor === ID_INVERSOR) {
              tipo = "Inversor";
            } else if (tipo_inversor === ID_MICROINVERSOR) {
              tipo = "Microinversor";
            }
        
            return(<TableCell className={changed ? classes.alterado : classes.historico_selecionado}>{tipo || "-"}</TableCell>)
          })}
        </>)
      case "fator_perdas":
        return(<>
          {projetos.map((_historico: any)=>{
            const { projeto } = _historico;
            const fator = Formater.toString(projeto?.solucao_sugerida?.fator_perdas || 0, TypeRecords.DECIMAL2) + "%"; 
            return(<TableCell className={changed ? classes.alterado : classes.historico_selecionado}>{fator}</TableCell>)
          })}
        </>)
      case "simultaneidade":
        return(<>
          {projetos.map((_historico: any)=>{
            const { projeto } = _historico;
            const simultaneidade = Formater.toString(projeto?.simultaneidade || 0, TypeRecords.DECIMAL2) + "%"; 
            return(<TableCell className={changed ? classes.alterado : classes.historico_selecionado}>{simultaneidade}</TableCell>)
          })}
        </>)
      case "estabelecimento":
        return(<>
          {projetos.map((_historico: any)=>{
            const { projeto } = _historico;
            return(<TableCell className={changed ? classes.alterado : classes.historico_selecionado}>{Formater.toString((projeto?.estabelecimento || "")) || "-"}</TableCell>)
          })}
        </>)
      case "potencia_desejada":
        return(<>
          {projetos.map((_historico: any)=>{
            const { projeto } = _historico;
            const potencia_desejada = projeto?.solucao_sugerida?.potencia ? Formater.toString(projeto?.solucao_sugerida?.potencia, TypeRecords.DECIMAL2)+" kWp" : null;
            return(<TableCell className={changed ? classes.alterado : classes.historico_selecionado}>{potencia_desejada || "-"}</TableCell>)
          })}
        </>)
      case "potencia":
        return(<>
          {projetos.map((_historico: any)=>{
            const { projeto } = _historico;
            const potencia = projeto?.potencia ? Formater.toString(projeto?.potencia, TypeRecords.DECIMAL2)+" kWp" : null;
            return(<TableCell className={changed ? classes.alterado : classes.historico_selecionado}>{potencia || "-"}</TableCell>)
          })}
        </>)
      case "concessionaria":
        return(<>
          {projetos.map((_historico: any)=>{
            const { projeto } = _historico;
            const {dados_concessionaria_payback} = projeto;
            return(<TableCell className={changed ? classes.alterado : classes.historico_selecionado}>{dados_concessionaria_payback?.agente|| "-"}</TableCell>)
          })}
        </>)
      case "preco_kwh":
        return(<>
          {projetos.map((_historico: any)=>{
            const { projeto } = _historico;
            const preco = Formater.toString(Number(projeto.preco_kwh || 0), TypeRecords.CURRENCY) || null;
            return(<TableCell className={changed ? classes.alterado : classes.historico_selecionado}>{preco || "-"}</TableCell>)
          })}
        </>)
      case "nome_modulo":
        return(<>
          {projetos.map((_historico: any)=>{
            const { projeto } = _historico;
            let modelo = "";
            if (projeto?.componentes) {
              /*const modulo = projeto?.componentes?.find((_c: any)=>{
                const _componenteCache = componentes?.data?.find((c: any)=> c?.id === _c?.componente_id);
                return _componenteCache?.categoria_componentes_id === 1;
              });*/
              const modulos = projeto?.componentes?.filter((_comp: any)=>{
                const _componenteCache = componentes?.data?.find((c: any)=> c?.id === _comp?.componente_id);
                return _componenteCache?.categoria_componentes_id === 1;
              })
              /*
              if (modulo) {
                const _modelo = componentes?.data?.find((componente: any) => componente.id === modulo?.componente_id) || null;
                modelo = _modelo?.modelo || null;
              }*/
              if (modulos?.length) {
                modulos?.forEach((x: any)=>{
                  const _modelo = componentes?.data?.find((componente: any) => componente.id === x.componente_id) || null;
                  if (!modelo) {
                    modelo += `${_modelo?.modelo}`
                  } else{
                    modelo += `/${_modelo?.modelo}`;
                  }
                })
              }
            }/*
            if (projeto?.solucao_sugerida && projeto?.tipo === "dimensionado") {
              const modulo = projeto?.solucao_sugerida?.componentes?.find((_c: any) => {
                const _componenteCache = componentes?.data?.find((c: any) => c?.id === _c?.id);
                return _componenteCache?.categoria_componentes_id === 1;
              });
  
              if (modulo) {
                  const _modelo = componentes?.data?.find((componente: any) => componente.id === modulo?.id) || null;
                  modelo = _modelo?.modelo || null; 
              }
            } else if (projeto?.tipo === "personalizado" || projeto?.tipo === "kit") {
              const modulo = projeto?.componentes?.find((_c: any)=>{
                const _componenteCache = componentes?.data?.find((c: any)=> c?.id === _c?.componente_id);
                return _componenteCache?.categoria_componentes_id === 1;
              });

              if (modulo) {
                const _modelo = componentes?.data?.find((componente: any) => componente.id === modulo?.componente_id) || null;
                modelo = _modelo?.modelo || null;
              }
            }*/
            return(<TableCell className={changed ? classes.alterado : classes.historico_selecionado}>{modelo || "-"}</TableCell>)
          })}
        </>)
      case "disposicao":
        return(<>
          {projetos.map((_historico: any)=>{
            let fileiraProjetos: ReactNode | null = null;
            let tableFileiras: ReactNode | null = null;
            const { projeto } = _historico;
            if (projeto?.solucao_sugerida && projeto?.tipo === "dimensionado") {
              fileiraProjetos = projeto?.solucao_sugerida?.fileiras?.map((fileira: any) => {
                const _estrutura = estruturas?.data?.find((estrutura: any) => {
                  if (estrutura?.dados_migracao?.id) return estrutura?.dados_migracao?.id === fileira?.estrutura_id;
                  return estrutura?.id === fileira?.estrutura_id;
                })?.nome || 'Sem estrutura';
                return <>
                    <TableRow>
                        <TableCell>{_estrutura}</TableCell>
                        <TableCell>{fileira?.fileiras_iguais}</TableCell>
                        <TableCell>{fileira?.modulos_sequencia}</TableCell>
                        <TableCell>{fileira?.posicao === "retrato" ? "Retrato" : "Paisagem"}</TableCell>
                    </TableRow>
                </>
            }); 
            }
            if (fileiraProjetos) {
              tableFileiras = 
              <TableContainer>
                  <Table size="small">
                      <TableHead>
                          <TableRow>
                              <TableCell style={{fontWeight: 'bold'}} width="auto">Estrutura</TableCell>
                              <TableCell style={{fontWeight: 'bold'}} width="auto" /*align="right"*/>Fileiras iguais</TableCell>
                              <TableCell style={{fontWeight: 'bold'}} width="auto">Modulos sequência</TableCell>
                              <TableCell style={{fontWeight: 'bold'}} width="auto">Posição</TableCell>
                          </TableRow>
                      </TableHead>
                      <TableBody>
                          {fileiraProjetos}
                      </TableBody>
                  </Table>
              </TableContainer>
            }
            return(<TableCell className={changed ? classes.alterado : classes.historico_selecionado}>{tableFileiras || "-"}</TableCell>)
          })}
        </>)
      case "tipo_proposta":
        return(<>
          {projetos.map((_historico: any)=>{
            const { projeto } = _historico;
            let tipo = projeto?.valor_servico ? "Gerador com Serviço de Instalação" : "Apenas Gerador sem Instalação";
            if (projeto?.tipo_proposta) tipo = projeto?.tipo_proposta;
            return(<TableCell className={changed ? classes.alterado : classes.historico_selecionado}>{tipo || "-"}</TableCell>)
          })}
        </>)
      case "percentual_comissao_distribuidor":
        return(<>
          {projetos.map((_historico: any)=>{
            const { projeto } = _historico;
            return(<TableCell className={changed ? classes.alterado : classes.historico_selecionado}>{Formater.toString(projeto?.percentual_comissao_distribuidor || 0, TypeRecords.DECIMAL2) + "%" || "-"}</TableCell>)
          })}
        </>)
      case "valor_produtos":
        return(<>
          {projetos.map((_historico: any)=>{
            const { projeto } = _historico;
            return(<TableCell className={changed ? classes.alterado : classes.historico_selecionado}>{Formater.toString((projeto?.valor || 0), TypeRecords.CURRENCY) || "-"}</TableCell>)
          })}
        </>)
      case "valor_produtos_desconto":
        return(<>
          {projetos.map((_historico: any)=>{
            const { projeto } = _historico;
            return(<TableCell className={changed ? classes.alterado : classes.historico_selecionado}>{Formater.toString((projeto?.valor - (projeto.valor_desconto || 0) || 0), TypeRecords.CURRENCY) || "-"}</TableCell>)
          })}
        </>)
      case "valor_instalacao":
        return(<>
          {projetos.map((_historico: any)=>{
            const { projeto } = _historico;
            return(<TableCell className={changed ? classes.alterado : classes.historico_selecionado}>{Formater.toString((projeto?.valor_servico || 0), TypeRecords.CURRENCY) || "-"}</TableCell>)
          })}
        </>)
      case "valor_margem":
        return(<>
          {projetos.map((_historico: any)=>{
            const { projeto } = _historico;
            return(<TableCell className={changed ? classes.alterado : classes.historico_selecionado}>{Formater.toString((projeto?.valor_margem_produtos || 0), TypeRecords.CURRENCY) || "-"}</TableCell>)
          })}
        </>)
      case "valor_servico":
        return(<>
          {projetos.map((_historico: any)=>{
            const { projeto } = _historico;
            return(<TableCell className={changed ? classes.alterado : classes.historico_selecionado}>{Formater.toString(((projeto?.valor_servico || 0) + (projeto?.valor_margem_produtos || 0)), TypeRecords.CURRENCY) || "-"}</TableCell>)
          })}
        </>)
      case "valor_servico_pis_cofins":
        return(<>
          {projetos.map((_historico: any)=>{
            const { projeto } = _historico;
            return(<TableCell className={changed ? classes.alterado : classes.historico_selecionado}>{Formater.toString((projeto?.valor_servico_pis_cofins || 0), TypeRecords.CURRENCY) || "-"}</TableCell>)
          })}
        </>)
      case "valor_total":
        return(<>
          {projetos.map((_historico: any)=>{
            const { projeto } = _historico;
            return(<TableCell className={changed ? classes.alterado : classes.historico_selecionado}>{Formater.toString((projeto?.valor_projeto || 0), TypeRecords.CURRENCY) || "-"}</TableCell>)
          })}
        </>)
      case "termos_aceite":
        return(<>
          {projetos.map((_historico: any)=>{
            const { projeto } = _historico;
            let termos: ReactNode | null = null;
            if (projeto?.termos_aceite) {
              termos = (
                <div className="X12" style={{marginBottom: "10px"}}>
                  <Alert severity="success">
                    <div dangerouslySetInnerHTML={{__html: projeto?.termos_aceite || ""}}/>
                  </Alert>
                </div>)
            }
            return(<TableCell className={changed ? classes.alterado : classes.historico_selecionado}>{termos || "-"}</TableCell>)
          })}
        </>)
      case "endereco":
        return (
          <>
            {projetos.map((_historico: any)=>{
              const { projeto } = _historico;
              const cidadeId = projeto?.cidade_id || projeto?.cidade?.id;

              let endereco = "";
              const semEndereco = (!projeto?.endereco || !projeto?.endereco?.logradouro);
              if (semEndereco && projeto?.endereco_proposta) {
                endereco = projeto.endereco_proposta;
              } else if (projeto?.endereco && cidadeId) {
                const cidade = projeto?.cidade || cidades?.data?.find((cidade: any) => cidade.id === projeto?.endereco?.cidade_id);
                if (projeto?.endereco?.logradouro) {
                  endereco += projeto?.endereco?.logradouro;
                }
                if (endereco) {
                    if (projeto?.endereco?.numero) {
                      endereco += `, ${projeto?.endereco?.numero}`;
                    } else endereco += ', SN';
                }

                if (projeto?.endereco?.bairro && endereco) {
                  endereco += ` - ${projeto?.endereco?.bairro}`;
                }

                if (cidade && projeto?.endereco?.estado_id && endereco) {
                  endereco += ` - ${cidade?.nome}/${projeto?.endereco?.estado_id}`;
                }
                if (projeto?.endereco?.cep && endereco) {
                  endereco += ` - ${projeto?.endereco?.cep?.replace(/^(\d{5})(\d)/, "$1-$2")}`
                }
                if (!endereco && cidade) {
                  endereco += `${cidade?.nome}/${projeto?.endereco?.estado_id}`;
                }
              }
              return(<TableCell className={changed ? classes.alterado : classes.historico_selecionado}>{endereco ||"-"}</TableCell>)
            })}
          </>
        );
      case "consumo":
        return(<>
          {projetos.map((_historico: any)=>{
            let consumoList: ReactNode | null = null;
            const { projeto } = _historico;
            if (projeto?.solucao_sugerida?.consumo?.length) {
              const consumo = arraySort(projeto?.solucao_sugerida?.consumo, 'dia', 'date');
              consumoList = <ul>
                {consumo?.map((cons: any) =>{
                  const _dia = moment(cons?.dia).format("MM/YYYY")
                  return <li key={cons.dia}>
                    <strong>{_dia}</strong> - {cons?.consumo} kWh
                  </li>
                })}
                
              </ul>
            }
            return(<TableCell className={changed ? classes.alterado : classes.historico_selecionado}>{consumoList ||"-"}</TableCell>)
          })}
        </>)
          
      default:
        return(<>
        {projetos.map((_historico: any)=>{
          return(
            <TableCell className={changed ? classes.alterado : classes.historico_selecionado}>{_historico?.projeto?.[campo] || "-"}</TableCell>
          )
        })}</>)
    }})

  useEffect(()=>{
    if(categoriasComponentes?.data?.length){
      setCategoriaComponentesState(categoriasComponentes?.data)
    }
  },[categoriasComponentes])
  return (<>
    <TableContainer className='table-historico' sx={{ overflowX: "auto" }}>
        <Table size="small">
            <TableHead>
                <TableRow>
                    <TableCell></TableCell>
                    {props.dados.map(_historico=>{
                      return(
                        <TableCell 
                          key={_historico.id}
                          style={{fontWeight: "bold"}}
                        >
                          Projeto em: {maskDate(_historico?.data_alteracao || "", true)}
                        </TableCell>
                      )
                    })}                    
                </TableRow>
            </TableHead>
            <TableBody>
                <TableRow>
                    <TableCell className={classes.header} colSpan={props?.dados?.length+1 || 1}>Componentes</TableCell>
                </TableRow>
                <TableRow className={`row ${props?.changeState?.componentes?.hasChanged ? classes.alterado : ""}`}>
                    <TableCell className={classes.titulo}>Componentes</TableCell>
                    {compareRow("componentes", props.dados, props?.changeState?.componentes?.hasChanged)}
                </TableRow>

                <TableRow>
                    <TableCell className={classes.header} colSpan={props?.dados?.length+1 || 1}>Projeto</TableCell>
                </TableRow>
                <TableRow className={`row ${props?.changeState?.codigo_venda?.hasChanged ? classes.alterado : ""}`}>
                    <TableCell className={classes.titulo}>Código Projeto</TableCell>
                    {compareRow("codigo_venda", props.dados, props?.changeState?.codigo_venda?.hasChanged)}
                </TableRow>
                <TableRow className={`row ${props?.changeState?.titulo?.hasChanged ? classes.alterado : ""}`}>
                    <TableCell className={classes.titulo}>Título</TableCell>
                    {compareRow("titulo", props.dados, props?.changeState?.titulo?.hasChanged)}
                </TableRow>
                <TableRow className={`row ${props?.changeState?.distribuidor?.hasChanged ? classes.alterado : ""}`}>
                    <TableCell className={classes.titulo}>Distribuidor</TableCell>
                    {compareRow("distribuidor", props.dados, props?.changeState?.distribuidor?.hasChanged)}
                </TableRow>
                <TableRow className={`row ${props?.changeState?.revenda?.hasChanged ? classes.alterado : ""}`}>
                    <TableCell className={classes.titulo}>Revenda</TableCell>
                    {compareRow("revenda", props.dados, props?.changeState?.revenda?.hasChanged)}
                </TableRow>
                <TableRow className={`row ${props?.changeState?.status_projeto?.hasChanged ? classes.alterado : ""}`}>
                    <TableCell className={classes.titulo}>Etapa de Venda</TableCell>
                    {compareRow("status_projeto", props.dados, props?.changeState?.status_projeto?.hasChanged)}
                </TableRow>
                {/* <TableRow className={`row ${props?.changeState?.status_projeto_pagamento?.hasChanged ? classes.alterado : ""}`}>
                    <TableCell className={classes.titulo}>Status de Pagamento</TableCell>
                    {compareRow("status_projeto_pagamento", props.dados, props?.changeState?.status_projeto_pagamento?.hasChanged)}
                </TableRow> */}
                <TableRow className={`row ${props?.changeState?.expirado?.hasChanged ? classes.alterado : ""}`}>
                    <TableCell className={classes.titulo}>Expirado</TableCell>
                    {compareRow("expirado", props.dados, props?.changeState?.expirado?.hasChanged)}
                </TableRow>
                <TableRow className={`row ${props?.changeState?.aceitou_termos?.hasChanged ? classes.alterado : ""}`}>
                    <TableCell className={classes.titulo}>Aceitou os termos</TableCell>
                    {compareRow("aceitou_termos", props.dados, props?.changeState?.aceitou_termos?.hasChanged)}
                </TableRow>
                <TableRow className={`row ${props?.changeState?.termos_projeto?.hasChanged ? classes.alterado : ""}`}>
                    <TableCell className={classes.titulo}>Termos do projeto</TableCell>
                    {compareRow("termos_projeto", props.dados, props?.changeState?.termos_projeto?.hasChanged)}
                </TableRow>
                <TableRow className={`row ${props?.changeState?.previsao_faturamento?.hasChanged ? classes.alterado : ""}`}>
                    <TableCell className={classes.titulo}>Previsão de faturamento</TableCell>
                    {compareRow("previsao_faturamento", props.dados, props?.changeState?.previsao_faturamento?.hasChanged)}
                </TableRow>
                <TableRow className={`row ${props?.changeState?.tipo_faturamento?.hasChanged ? classes.alterado : ""}`}>
                    <TableCell className={classes.titulo}>Tipo de Faturamento</TableCell>
                    {compareRow("tipo_faturamento", props.dados, props?.changeState?.tipo_faturamento?.hasChanged)}
                </TableRow>
                <TableRow className={`row ${props?.changeState?.tipo?.hasChanged ? classes.alterado : ""}`}>
                    <TableCell className={classes.titulo}>Tipo de Projeto</TableCell>
                    {compareRow("tipo", props.dados, props?.changeState?.tipo?.hasChanged)}
                </TableRow>
                {/*INICIO SECAO DE DADOS DE CLIENTES*/}
                <TableRow>
                    <TableCell className={classes.header} colSpan={props?.dados?.length+1 || 1}>Cliente</TableCell>
                </TableRow>
                <TableRow className={`row ${props?.changeState?.cliente_proposta?.hasChanged ? classes.alterado : ""}`}>
                    <TableCell className={classes.titulo}>Nome</TableCell>
                    {compareRow("cliente_proposta", props.dados, props?.changeState?.cliente_proposta?.hasChanged)}
                </TableRow>
                <TableRow className={`row ${props?.changeState?.cpf_cnpj_proposta?.hasChanged ? classes.alterado : ""}`}>
                    <TableCell className={classes.titulo}>CPF/CNPJ</TableCell>
                    {compareRow("cpf_cnpj_proposta", props.dados, props?.changeState?.cpf_cnpj_proposta?.hasChanged)}
                </TableRow>
                <TableRow className={`row ${props?.changeState?.email_proposta?.hasChanged ? classes.alterado : ""}`}>
                    <TableCell className={classes.titulo}>E-mail</TableCell>
                    {compareRow("email_proposta", props.dados, props?.changeState?.email_proposta?.hasChanged)}
                </TableRow>
                <TableRow className={`row ${props?.changeState?.endereco?.hasChanged ? classes.alterado : ""}`}>
                    <TableCell className={classes.titulo}>Endereço</TableCell>
                    {compareRow("endereco", props.dados, props?.changeState?.endereco?.hasChanged)}
                </TableRow>
                {/*FIM SECAO DE DADOS DE CLIENTES*/}
                {/*INICIO SECAO DE DADOS DA CONFIGURACAO*/}
                <TableRow>
                    <TableCell className={classes.header} colSpan={props?.dados?.length+1 || 1}>Configuração</TableCell>
                </TableRow>
                <TableRow className={`row ${props?.changeState?.tensao?.hasChanged ? classes.alterado : ""}`}>
                    <TableCell className={classes.titulo}>Tensão</TableCell>
                    {compareRow("tensao", props.dados, props?.changeState?.tensao?.hasChanged)}
                </TableRow>
                <TableRow className={`row ${props?.changeState?.inversor_tipo_conexao?.hasChanged ? classes.alterado : ""}`}>
                    <TableCell className={classes.titulo}>Fase</TableCell>
                    {compareRow("inversor_tipo_conexao", props.dados, props?.changeState?.inversor_tipo_conexao?.hasChanged)}
                </TableRow>
                <TableRow className={`row ${props?.changeState?.tipo_inversor?.hasChanged ? classes.alterado : ""}`}>
                    <TableCell className={classes.titulo}>Tipo Inversor</TableCell>
                    {compareRow("tipo_inversor", props.dados, props?.changeState?.tipo_inversor?.hasChanged)}
                </TableRow>
                <TableRow className={`row ${props?.changeState?.fator_perdas?.hasChanged ? classes.alterado : ""}`}>
                    <TableCell className={classes.titulo}>Fator de perdas (%)</TableCell>
                    {compareRow("fator_perdas", props.dados, props?.changeState?.fator_perdas?.hasChanged)}
                </TableRow>
                {/* <TableRow className={`row ${props?.changeState?.concessionaria?.hasChanged ? classes.alterado : ""}`}>
                    <TableCell className={classes.titulo}>Concessionária</TableCell>
                    {compareRow("concessionaria", props.dados, props?.changeState?.concessionaria?.hasChanged)}
                </TableRow> */}
                {/* <TableRow className={`row ${props?.changeState?.simultaneidade?.hasChanged ? classes.alterado : ""}`}>
                    <TableCell className={classes.titulo}>Simultaneidade</TableCell>
                    {compareRow("simultaneidade", props.dados, props?.changeState?.simultaneidade?.hasChanged)}
                </TableRow> */}
                <TableRow className={`row ${props?.changeState?.potencia_desejada?.hasChanged ? classes.alterado : ""}`}>
                    <TableCell className={classes.titulo}>Potência desejada</TableCell>
                    {compareRow("potencia_desejada", props.dados, props?.changeState?.potencia_desejada?.hasChanged)}
                </TableRow>
                <TableRow className={`row ${props?.changeState?.potencia?.hasChanged ? classes.alterado : ""}`}>
                    <TableCell className={classes.titulo}>Potência do gerador</TableCell>
                    {compareRow("potencia", props.dados, props?.changeState?.potencia?.hasChanged)}
                </TableRow>
                <TableRow className={`row ${props?.changeState?.consumo?.hasChanged ? classes.alterado : ""}`}>
                    <TableCell className={classes.titulo}>Consumo</TableCell>
                    {compareRow("consumo", props.dados, props?.changeState?.consumo?.hasChanged)}
                </TableRow>
                <TableRow className={`row ${props?.changeState?.preco_kwh?.hasChanged ? classes.alterado : ""}`}>
                    <TableCell className={classes.titulo}>Preço do kWh</TableCell>
                    {compareRow("preco_kwh", props.dados, props?.changeState?.preco_kwh?.hasChanged)}
                </TableRow>
                <TableRow className={`row ${props?.changeState?.nome_modulo?.hasChanged ? classes.alterado : ""}`}>
                    <TableCell className={classes.titulo}>Nome do módulo</TableCell>
                    {compareRow("nome_modulo", props.dados, props?.changeState?.nome_modulo?.hasChanged)}
                </TableRow>
                <TableRow className={`row ${props?.changeState?.disposicao?.hasChanged ? classes.alterado : ""}`}>
                    <TableCell className={classes.titulo}>Disposição dos módulos</TableCell>
                    {compareRow("disposicao", props.dados, props?.changeState?.disposicao?.hasChanged)}
                </TableRow>

                {/*FIM SECAO DE DADOS DA CONFIGURACAO*/}
                {/*INICIO SECAO DE DADOS FINANCEIROS*/}
                <TableRow>
                    <TableCell className={classes.header} colSpan={props?.dados?.length+1 || 1}>Financeiro</TableCell>
                </TableRow>
                <TableRow className={`row ${props?.changeState?.tipo_proposta?.hasChanged ? classes.alterado : ""}`}>
                    <TableCell className={classes.titulo}>Tipo Proposta</TableCell>
                    {compareRow("tipo_proposta", props.dados, props?.changeState?.tipo_proposta?.hasChanged)}
                </TableRow>
                <TableRow className={`row ${props?.changeState?.percentual_comissao_distribuidor?.hasChanged ? classes.alterado : ""}`}>
                    <TableCell className={classes.titulo}>Comissão Projeto</TableCell>
                    {compareRow("percentual_comissao_distribuidor", props.dados, props?.changeState?.percentual_comissao_distribuidor?.hasChanged)}
                </TableRow>
                <TableRow className={`row ${props?.changeState?.valor_produtos?.hasChanged ? classes.alterado : ""}`}>
                    <TableCell className={classes.titulo}>Valor Produtos</TableCell>
                    {compareRow("valor_produtos", props.dados, props?.changeState?.valor_produtos?.hasChanged)}
                </TableRow>
                <TableRow className={`row ${props?.changeState?.valor_produtos_desconto?.hasChanged ? classes.alterado : ""}`}>
                    <TableCell className={classes.titulo}>Valor Produtos com Desconto</TableCell>
                    {compareRow("valor_produtos_desconto", props.dados, props?.changeState?.valor_produtos_desconto?.hasChanged)}
                </TableRow>
                <TableRow className={`row ${props?.changeState?.valor_instalacao?.hasChanged ? classes.alterado : ""}`}>
                    <TableCell className={classes.titulo}>Valor Instalação</TableCell>
                    {compareRow("valor_instalacao", props.dados, props?.changeState?.valor_instalacao?.hasChanged)}
                </TableRow>
                <TableRow className={`row ${props?.changeState?.valor_margem?.hasChanged ? classes.alterado : ""}`}>
                    <TableCell className={classes.titulo}>Valor Margem</TableCell>
                    {compareRow("valor_margem", props.dados, props?.changeState?.valor_margem?.hasChanged)}
                </TableRow>
                <TableRow className={`row ${props?.changeState?.valor_servico?.hasChanged ? classes.alterado : ""}`}>
                    <TableCell className={classes.titulo}>Valor Serviço</TableCell>
                    {compareRow("valor_servico", props.dados, props?.changeState?.valor_servico?.hasChanged)}
                </TableRow>
                <TableRow className={`row ${props?.changeState?.valor_servico_pis_cofins?.hasChanged ? classes.alterado : ""}`}>
                    <TableCell className={classes.titulo}>Valor Serviço com PIS/COFINS</TableCell>
                    {compareRow("valor_servico_pis_cofins", props.dados, props?.changeState?.valor_servico_pis_cofins?.hasChanged)}
                </TableRow>
                <TableRow className={`row ${props?.changeState?.valor_total?.hasChanged ? classes.alterado : ""}`}>
                    <TableCell className={classes.titulo}>Valor Total</TableCell>
                    {compareRow("valor_total", props.dados, props?.changeState?.valor_total?.hasChanged)}
                </TableRow>
                {/*FIM SECAO DE DADOS FINANCEIROS*/}
                <TableRow>
                    <TableCell className={classes.header} colSpan={props?.dados?.length+1 || 1}>Logística</TableCell>
                </TableRow>
                <TableRow className={`row ${props?.changeState?.estabelecimento?.hasChanged ? classes.alterado : ""}`}>
                    <TableCell className={classes.titulo}>Estabelecimento</TableCell>
                    {compareRow("estabelecimento", props.dados, props?.changeState?.estabelecimento?.hasChanged)}
                </TableRow>
                <TableRow>
                    <TableCell className={classes.header} colSpan={props?.dados?.length+1 || 1}>Termos de Aceite</TableCell>
                </TableRow>
                <TableRow className={`row ${props?.changeState?.termos_aceite?.hasChanged ? classes.alterado : ""}`}>
                    <TableCell className={classes.titulo}>Termos de Aceite</TableCell>
                    {compareRow("termos_aceite", props.dados, props?.changeState?.termos_aceite?.hasChanged)}
                </TableRow>

            </TableBody>            
        </Table>
    </TableContainer>
  </>);
};

export default TabelaComparacaoProjetos;
